import React, {} from 'react';
import { joinClassNames } from './joinClassNames.js';
const styles = {"box":"Box-module__box__UtXt7","surfaceGround":"Box-module__surfaceGround__k6M5Z","surfaceSurface":"Box-module__surfaceSurface__h6M-d","surfaceTint":"Box-module__surfaceTint__eTKS9","surfacePanel":"Box-module__surfacePanel__-6cHF","paddingNone":"Box-module__paddingNone__4Bs2r","paddingSmall":"Box-module__paddingSmall__7VWeF","paddingMedium":"Box-module__paddingMedium__9mwyv","paddingLarge":"Box-module__paddingLarge__NPTax","paddingExtraLarge":"Box-module__paddingExtraLarge__frk8t"};
const SURFACE_CLASS_NAMES = {
    ground: styles.surfaceGround,
    surface: styles.surfaceSurface,
    tint: styles.surfaceTint,
    panel: styles.surfacePanel
};
const PADDING_CLASS_NAMES = {
    none: styles.paddingNone,
    small: styles.paddingSmall,
    medium: styles.paddingMedium,
    large: styles.paddingLarge,
    extraLarge: styles.paddingExtraLarge
};
/** The layout base every other part builds on. */
export function Box({ as: Element = 'div', surface, padding = 'none', children }) {
    let surfaceClassName;
    if (surface !== undefined) {
        surfaceClassName = SURFACE_CLASS_NAMES[surface];
    }
    return React.createElement(Element, { className: joinClassNames(styles.box, surfaceClassName, PADDING_CLASS_NAMES[padding]) }, children);
}
//# sourceMappingURL=Box.js.map